import Rollbar from 'rollbar'

const rollbar = new Rollbar({
  accessToken: process.env.ROLLBAR_POST_CLIENT_ITEM,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.ENV
})

export default rollbar



// WEBPACK FOOTER //
// ./src/services/rollbar/index.js